/**
 * Shared chunk material — vertex colors, no textures (atlas later).
 *
 * MeshLambertMaterial: much cheaper than Standard on iGPU / Surface
 * (no PBR specular loop). Cozy pastel lighting still reads well under
 * hemisphere + single directional.
 */
import * as THREE from "three";

let cached: THREE.MeshLambertMaterial | null = null;

export function getChunkMaterial(): THREE.MeshLambertMaterial {
  if (cached) return cached;
  cached = new THREE.MeshLambertMaterial({
    vertexColors: true,
    flatShading: true,
    // Slightly less fill work when backfaces would still be culled by depth
    side: THREE.FrontSide,
  });
  return cached;
}
